import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const getOpsFLowTypeRoles = (opsFLowTypeId) => {
  return axios.request({
    url: workFlowBaseUrl + 'ops_flow_roles/' + opsFLowTypeId + '/get/',
    method: 'get'
  })
}

export const modifyOpsFLowTypeRoles = (data, opsFLowTypeId) => {
  return axios.request({
    url: workFlowBaseUrl + 'ops_flow_roles/' + opsFLowTypeId + '/modify/',
    data: data,
    traditional: true,
    method: 'post'
  })
}

// 取类型列表（带分页）
export const getOpsFLowTypes = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'ops_flow_type/',
    params: params,
    method: 'get'
  })
}

// 所有类型列表
export const getAllOpsTypes = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'all_ops_flow_type/',
    params: params,
    method: 'get'
  })
}

// 运维流程详情
export const detailOpsFLowTypes = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'ops_flow_type/' + id + '/',
    method: 'get'
  })
}

// 编辑运维流程信息
export const changeOpsFLowType = (data, id) => {
  let url = workFlowBaseUrl + 'ops_flow_type/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

// 删除运维流程
export const deleteOpsFLowType = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'ops_flow_type/' + id + '/',
    method: 'delete'
  })
}
